<template>
  <div class="page">
    <div class="page__bd">
      <div class="form-preview weui-form-preview">
        <div class="weui-form-preview__bd">
          <div class="weui-form-preview__item">
            <label class="weui-form-preview__label">批号</label>
            <span class="weui-form-preview__value">{{initData.ba_code}}</span>
          </div>
          <div class="weui-form-preview__item">
            <label class="weui-form-preview__label">物料编号</label>
            <span class="weui-form-preview__value">{{initData.pr_code}}</span>
          </div>
          <div class="weui-form-preview__item">
            <label class="weui-form-preview__label">厂家/品牌</label>
            <span class="weui-form-preview__value">{{initData.pr_brand}}</span>
          </div>
          <div class="weui-form-preview__item">
            <label class="weui-form-preview__label">物料名称</label>
            <span class="weui-form-preview__value">{{initData.pr_detail}}</span>
          </div>
          <div class="weui-form-preview__item">
            <label class="weui-form-preview__label">型号</label>
            <span class="weui-form-preview__value">{{initData.pr_orispeccode}}</span>
          </div>
          <div class="weui-form-preview__item">
            <label class="weui-form-preview__label">规格</label>
            <span class="weui-form-preview__value">{{initData.pr_spec}}</span>
          </div>
          <div class="weui-form-preview__item">
            <label class="weui-form-preview__label">入库日期</label>
            <span class="weui-form-preview__value" v-format="'yyyy-MM-dd'">{{initData.ba_date}}</span>
          </div>
          <div class="weui-form-preview__item">
            <label class="weui-form-preview__label">剩余数量</label>
            <span class="weui-form-preview__value">{{initData.ba_remain}}</span>
          </div>
          <div class="weui-form-preview__item">
            <label class="weui-form-preview__label">入库数量</label>
            <span class="weui-form-preview__value">{{initData.ba_inqty}}</span>
          </div>
          <div class="weui-form-preview__item">
            <label class="weui-form-preview__label">出库数量</label>
            <span class="weui-form-preview__value">{{initData.ba_outqty}}</span>
          </div>
          <div class="weui-form-preview__item">
            <label class="weui-form-preview__label">单位</label>
            <span class="weui-form-preview__value">{{initData.pr_unit}}</span>
          </div>
          <div class="weui-form-preview__item">
            <label class="weui-form-preview__label">仓库</label>
            <span class="weui-form-preview__value">{{initData.wh_description}}</span>
          </div>
          <div class="weui-form-preview__item">
            <label class="weui-form-preview__label">单据类型</label>
            <span class="weui-form-preview__value">{{initData.pd_piclass}}</span>
          </div>
          <div class="weui-form-preview__item">
            <label class="weui-form-preview__label">供应商</label>
            <span class="weui-form-preview__value">{{initData.pi_vendname}}</span>
          </div>
          <div class="weui-form-preview__item">
            <label class="weui-form-preview__label">入库单号</label>
            <span class="weui-form-preview__value">{{initData.pd_inoutno}}</span>
          </div>
          <div class="weui-form-preview__item">
            <label class="weui-form-preview__label">入库序号</label>
            <span class="weui-form-preview__value">{{initData.pd_pdno}}</span>
          </div>
          <div class="weui-form-preview__item">
            <label class="weui-form-preview__label">成本单价（元）</label>
            <span class="weui-form-preview__value" v-format="'#,##0.00'">{{initData.pd_price}}</span>
          </div>
          <div class="weui-form-preview__item">
            <label class="weui-form-preview__label">成本金额（元）</label>
            <span class="weui-form-preview__value" v-format="'#,##0.00'">{{initData.pd_total}}</span>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    initData: Object
  }
};
</script>